import {Route, Routes, Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Button, message } from "antd";
import type { ColumnsType } from "antd/es/table";
import { PageHeader } from "@ant-design/pro-layout";
import { DeleteOutlined } from "@ant-design/icons";
import {
  DeviceProfile,
} from "../../model/model";
import type { GetPageCallbackFunc } from "../../components/DataTable";
import DataTable from "../../components/DataTable";
import SessionStore from "../../model/SessionStore";
import EditDeviceProfile from "./EditDeviceProfile";
import DeleteConfirm from "../../components/DeleteConfirm";

function ListDeviceProfiles() {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const deleteDeviceProfile = (profile: DeviceProfile) => {
    SessionStore.getClient().removeDeviceProfile(profile.id, SessionStore.getBearer()).then(() => {
      messageApi.success("Device profile deleted");
      window.location.reload();
    }).catch(err => {
      if (err.status === 401) {
        navigate(`/login`);
      } else {
        messageApi.open({
          type: 'error',
          content: err.message,
        });
      }
    });
  };

  const columns: ColumnsType<DeviceProfile> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Link to={`/device-profiles/${record.id}/edit`}>{text}</Link>
      ),
    },
    {
      title: "Device profile",
      dataIndex: "device-profile",
      key: "device-profile",
      width: 150,
      render: (text, record) => {
        return record.decoder;
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      render: (_text, record) => (
        <DeleteConfirm confirm={record.name} typ="device profile" onConfirm={() => deleteDeviceProfile(record)}>
          <Button danger icon={<DeleteOutlined />} />
        </DeleteConfirm>
      ),
    },
  ];

  const getPage = (limit: number, offset: number, callbackFunc: GetPageCallbackFunc) => {
    
    SessionStore.getClient().getAllDeviceProfile(SessionStore.getBearer()).then((resp) => {
      callbackFunc(resp.data.length, resp.data);
    });
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      {contextHolder}
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Device profiles</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Device profiles"
        extra={[
            <Button type="primary">
              <Link to={`/device-profiles/create`}>Add deviceData profile</Link>
            </Button>
        ]}
      />
      <DataTable columns={columns} getPage={getPage} rowKey="id" />
    </Space>
  );
}

export default ListDeviceProfiles;
